<template>
  <div>
    <div class="card">
      <div class="card-header">
        <center>
          <h3>
            Reporte de pacientes
            <i class="fa fa-folder"></i>
          </h3>
        </center>
        <hr />
      </div>
      <div class="card-content">
        
          <div class="row">
            <div class="col-md-4" v-if="rol == 1">
              <label for="">Sede:</label>
              <select class="form-control" v-model="sede">
                <option

                  v-for="sede in SedesProgramacion"
                  :key="sede.sede"
                  :value="sede.sede"
                >
                  {{ sede.sede }}
                </option>
              </select>
              <br />
              <br />
            </div>
          </div>
          <center>
          <div class="row">
            <div class="col-md-4">
              <label for>Todos los pacientes:</label>
              <input v-model="tipo" value="1" type="radio" />
            </div>
            <div class="col-md-4">
              <label for>Tipo de cliente:</label>
              <input v-model="tipo" value="2" type="radio" />
            </div>
            <div class="col-md-4">
              <label for>Entidad:</label>
              <input v-model="tipo" value="3" type="radio" />
            </div>
          </div>
        </center>
        <div class="row">
          <div class="col-md-4">
            <label for="">Ver pacientes:</label>
            <select name="" id="" v-model="estado" class="form-control">
              <option :value="1">Activos</option>
              <option :value="0">Inactivos</option>
              <option :value="3">Todos</option>
            </select>
          </div>
        </div>
        <br />
        <br />

        <div class="row" v-if="tipo == 2">
          <div class="col-md-4">
            <label>Opciones:</label>
            <select v-model="tipocliente" class="form-control">
              <option value="2">PARTICULARES</option>
              <option value="3">CONVENIOS</option>
              <option value="4">PROYECTOS</option>
              <option value="6">EPS</option>
              <option value="7">PREPAGADAS</option>
              <option value="8">POLIZAS</option>
              <option value="5">OTROS</option>
            </select>
          </div>
        </div>

        <div class="row" v-if="tipo == 3">
          <div class="col-md-4">
            <label>Tipo de entidad:</label>
            <select v-model="tipoEntidad" class="form-control">
              <option value="EpsCod">EPS</option>
              <option value="PreCod">PREPAGADAS</option>
              <option value="PolCod">POLIZAS</option>
            </select>
          </div>
          <div class="col-md-2" v-if="tipoEntidad == 'EpsCod'">
            <label for="">Regimen:</label>
            <select
              @change="selectEps()"
              v-model="regimen"
              class="form-control"
            >
              <option value="1">Contributivo</option>
              <option value="2">Subsidiado</option>
            </select>
          </div>

          <div v-if="tipoEntidad == 'EpsCod'" class="col-md-4">
            <label>Entidad:</label>
            <select v-model="entidad" class="form-control">
              <option
                v-for="entidad in arrayEps"
                :key="entidad.EpsCod"
                :value="entidad.EpsCod"
              >
                {{ entidad.EpsNom }}
              </option>
            </select>
          </div>

          <div v-if="tipoEntidad == 'PreCod'" class="col-md-4">
            <label>Entidad:</label>
            <select v-model="entidad" class="form-control">
              <option
                v-for="entidad in arrayPrepagada"
                :key="entidad.EpsCod"
                :value="entidad.EpsCod"
              >
                {{ entidad.EpsNom }}
              </option>
            </select>
          </div>

          <div v-if="tipoEntidad == 'PolCod'" class="col-md-4">
            <label>Entidad:</label>
            <select v-model="entidad" class="form-control">
              <option
                v-for="entidad in arrayPoliza"
                :key="entidad.EpsCod"
                :value="entidad.EpsCod"
              >
                {{ entidad.EpsNom }}
              </option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <label for="">Especialidad:</label>
            <select class="form-control" v-model="especialidad">
              <option value="0">Todas</option>
              <option value="2">Fisioterapia</option>
              <option value="3">Fonoaudiología</option>
              <option value="4">Terapia Ocupacional</option>
              <option value="5">Educación Especial</option>
              <option value="6">Psicología</option>
            </select>
          </div>
        </div>

        <div class="row">
          <br />

          <div class="col-md-4">
            <label>Fecha inicial:</label>
            <input type="date" v-model="fecha_inicial" class="form-control" />
          </div>
          <div class="col-md-4">
            <label>Fecha final:</label>
            <input type="date" v-model="fecha_final" class="form-control" />
          </div>

          <div class="col-md-2">
            <label for></label>
            <br />
            <button
              @click="getPacientes()"
              style="border-radius: 5px"
              class="btn btn-success btn-fill"
            >
              <i class="fa fa-search"></i> Buscar
            </button>
          </div>
        </div>
        <br />
        <br />

        <!-- <div class="tabla"> -->
        <label for="">Cant. datos: {{ pacientes.length }}</label>
        <el-table class="table-striped" :data="pacientes" border>
          <el-table-column
            v-for="column in tableColumns"
            :key="column.label"
            :min-width="column.minWidth"
            :prop="column.prop"
            :label="column.label"
            else
          ></el-table-column>
        </el-table>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    estado: 1,
    especialidad: 0,
    tipo: 1,
    opciones_fecha: 2,
    tipocliente: 2,
    fecha_inicial: "",
    fecha_final: "",
    ip: "https://avanti-erp.com/api/",
    pacientes: [],
    tipoEntidad: "EpsCod",
    arrayEps: [],
    arrayPrepagada: [],
    arrayPoliza: [],
    entidad: 16,
    regimen: 1,
    sede: "Sede Principal",
    SedesProgramacion: [],
    rol: "",

    // tabla

    tableColumns: [
      {
        prop: "PacApe1", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Apellidos", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 150, //ANCHO DE LA COLUMNA
      },
      {
        prop: "PacNom1", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Nombres", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 150, //ANCHO DE LA COLUMNA
      },
      {
        prop: "entidad", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Entidad", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 150, //ANCHO DE LA COLUMNA
      },
      {
        prop: "Realizadas",
        label: "SSR",
        // minWidth: 150,
      },
      {
        prop: "Canceladas",
        label: "CE",
        // minWidth: 150,
      },
      {
        prop: "Sesiones Disponibles",
        label: "SSAs",
        // minWidth: 120,
      },
      {
        prop: "Autorizaciones",
        label: "Autorizaciones Activas",
        minWidth: 120,
      },
    ],
  }),
  methods: {
    selectEps() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var url = this.ip + "selectEps?reg=" + this.regimen;
      axios
        .get(url, config)
        .then((response) => {
          var respuesta = response.data;
          this.arrayEps = respuesta.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectPrepagada() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var url = this.ip + "selectPrepagada";
      axios
        .get(url, config)
        .then((response) => {
          var respuesta = response.data;
          this.arrayPrepagada = respuesta.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectPoliza() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var url = this.ip + "selectPoliza";
      axios
        .get(url, config)
        .then((response) => {
          var respuesta = response.data;
          this.arrayPoliza = respuesta.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPacientes: function () {
      this.$modal.show("carga");
      this.pacientes = [];
      const rol = localStorage.getItem("rol");
      const sede = rol == 1 ? this.sede : localStorage.getItem("sede");
      if (this.tipo == 1) {
        if (this.opciones_fecha == 1) {
          const BASE_URL = `${this.ip}reportes/pacientes/fecha/${this.fecha_inicial}/${this.fecha_inicial}/${sede}`;
          axios
            .get(BASE_URL)
            .then((res) => {
              let pacientes_activos = [];
              let data_pacientes = res.data.data;
              if (this.estado == 3) {
                this.pacientes = res.data.data;
              } else {
                for (let index = 0; index < data_pacientes.length; index++) {
                  if (data_pacientes[index].estado == this.estado) {
                    pacientes_activos.push(data_pacientes[index]);
                  }
                }
                this.pacientes = pacientes_activos;
              }
              // console.log(res);
              // this.$modal.hide("carga");
            })
            .catch((err) => {
              this.$modal.hide("carga");
              console.log(err);
            });
        } else {
          const BASE_URL = `${this.ip}reportes/pacientes/fecha/${this.fecha_inicial}/${this.fecha_final}/${this.especialidad}/${sede}`;
          axios
            .get(BASE_URL)
            .then((res) => {
              // console.log(res.data.data);
              let pacientes_activos = [];
              let data_pacientes = res.data.data;
              if (this.estado == 3) {
                this.pacientes = res.data.data;
              } else {
                for (let index = 0; index < data_pacientes.length; index++) {
                  if (data_pacientes[index].estado == this.estado) {
                    pacientes_activos.push(data_pacientes[index]);
                  }
                }
                this.pacientes = pacientes_activos;
              }
              this.$modal.hide("carga");
            })
            .catch((err) => {
              this.$modal.hide("carga");
              console.log(err);
            });
        }
      } else if (this.tipo == 2) {
        const BASE_URL = `${this.ip}reportes/pacientes/tipocliente/${this.tipocliente}/${this.fecha_inicial}/${this.fecha_final}/${this.especialidad}/${sede}`;
        axios
          .get(BASE_URL)
          .then((res) => {
            let pacientes_activos = [];
            let data_pacientes = res.data.data;
            if (this.estado == 3) {
              this.pacientes = res.data.data;
            } else {
              for (let index = 0; index < data_pacientes.length; index++) {
                if (data_pacientes[index].estado == this.estado) {
                  pacientes_activos.push(data_pacientes[index]);
                }
              }
              this.pacientes = pacientes_activos;
            }
            this.$modal.hide("carga");
          })
          .catch((err) => {
            this.$modal.hide("carga");
            console.log(err);
          });
      } else {
        const BASE_URL = `${this.ip}reportes/pacientes/entidad/${this.tipoEntidad}/${this.entidad}/${this.fecha_inicial}/${this.fecha_final}/${this.especialidad}/${sede}`;
        axios
          .get(BASE_URL)
          .then((res) => {
            let pacientes_activos = [];
            let data_pacientes = res.data.data;
            if (this.estado == 3) {
              this.pacientes = res.data.data;
            } else {
              for (let index = 0; index < data_pacientes.length; index++) {
                if (data_pacientes[index].estado == this.estado) {
                  pacientes_activos.push(data_pacientes[index]);
                }
              }
              this.pacientes = pacientes_activos;
            }
            this.$modal.hide("carga");
          })
          .catch((err) => {
            this.$modal.hide("carga");
            console.log(err);
          });
      }
    },
    emailsProgramacion: function () {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}emailsProgramacion`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          let data = res.data.data;
          this.SedesProgramacion = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.selectEps();
    this.selectPrepagada();
    this.selectPoliza();
    this.emailsProgramacion();
    this.rol = localStorage.getItem("rol");
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Reportes/Pacientes.vue